export const IS_LOGIN = "IS_LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
